export { ArchivedActivitiesPage, type ArchivedActivitiesPageProps } from "./ArchivedActivitiesPage"
